module.exports = __webpack_public_path__ + "static/sjova-5-45871b17eebf8d75353118058094ca00.jpg";